import React, { useEffect, useState } from 'react';
import { BarChart, Activity, Users, Star } from 'lucide-react';
import { getProcesos } from '../api';

const Reportes = () => {
  const [metricas, setMetricas] = useState({
    totalProcesos: 0,
    totalCandidatos: 0,
    porEtapa: {}
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getProcesos();
        let totalCands = 0;
        let conteoFases = {
          'Nuevos Postulantes': 0,
          'Hunting': 0,
          'Posibles': 0,
          'Entrevista Consultora': 0,
          'Entrevista Psicologica': 0,
          'Terna': 0,
          'Contratado': 0
        };

        res.data.forEach(proc => {
          proc.Candidatos.forEach(c => {
            totalCands++;
            if (conteoFases[c.etapa_actual] !== undefined) {
              conteoFases[c.etapa_actual]++;
            }
          });
        });

        setMetricas({
          totalProcesos: res.data.length,
          totalCandidatos: totalCands,
          porEtapa: conteoFases
        });
      } catch (e) {
        console.error(e);
      }
    };
    fetchData();
  }, []);

  const total = metricas.totalCandidatos || 1; // Para evitar división por cero

  return (
    <div className="p-8 w-full max-w-7xl mx-auto flex flex-col h-full overflow-y-auto">
      <h1 className="text-2xl font-bold text-gray-800 uppercase tracking-wider mb-6 flex items-center gap-2">
        <BarChart className="text-emeral-green" /> Reportes de Gestión
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-500 flex justify-center items-center"><Activity size={24}/></div>
          <div>
            <p className="text-sm font-bold text-gray-400 uppercase">Total Procesos</p>
            <h3 className="text-2xl font-black text-gray-800">{metricas.totalProcesos}</h3>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-green-50 text-emeral-green flex justify-center items-center"><Users size={24}/></div>
          <div>
            <p className="text-sm font-bold text-gray-400 uppercase">Volumen Candidatos</p>
            <h3 className="text-2xl font-black text-gray-800">{metricas.totalCandidatos}</h3>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-yellow-50 text-yellow-500 flex justify-center items-center"><Star size={24}/></div>
          <div>
            <p className="text-sm font-bold text-gray-400 uppercase">Tasa Contratación</p>
            <h3 className="text-2xl font-black text-gray-800">
              {((metricas.porEtapa['Contratado'] / total) * 100).toFixed(1)}%
            </h3>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
        <h2 className="text-lg font-bold text-gray-700 mb-6 uppercase text-sm border-b pb-2">Distribución del Embudo (Funnel)</h2>
        <div className="space-y-4">
          {Object.entries(metricas.porEtapa).map(([etapa, cantidad]) => {
            const porcentaje = ((cantidad / total) * 100).toFixed(1);
            return (
              <div key={etapa}>
                <div className="flex justify-between text-xs font-bold text-gray-600 mb-1">
                  <span className="uppercase">{etapa}</span>
                  <span>{cantidad} ({porcentaje}%)</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-3">
                  <div 
                    className="bg-emeral-green h-3 rounded-full transition-all duration-1000 ease-out" 
                    style={{ width: `${porcentaje}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Reportes;
